import type { Dispatch, SetStateAction } from 'react'
import { useState, useEffect } from 'react'
import { useScrollLock } from 'usehooks-ts'

// Oddly TS wouldn't infer the return type here...
const useModalState = (initialState = false): [boolean, Dispatch<SetStateAction<boolean>>] => {
	const [
		open,
		setOpen,
	] = useState(initialState)

	const { lock, unlock, isLocked } = useScrollLock({
		autoLock: false,
		lockTarget: '#scrollable',
	})

	useEffect(() => {
		if (open && !isLocked) {
			lock()
		} else if (!open && isLocked) {
			unlock()
		}
	}, [
		open,
		isLocked,
		lock,
		unlock,
	])

	return [
		open,
		setOpen,
	]
}

export default useModalState
